/**
 * Garde montée à la racine (`RootLayout`) : une déconnexion efface la session
 * de départ gardée pour le retour d'une bascule de compte (`admin-switch`) —
 * sinon un autre compte connecté plus tard sur l'appareil pourrait y revenir.
 * N'affiche rien : le sélecteur est le bouton « Changer de compte » des
 * tableaux de bord (`AccountSwitcher`).
 */
import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { clearAdminReturn } from '@/lib/admin/admin-switch';

export function AdminReturnGuard() {
  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT') clearAdminReturn();
    });
    return () => data.subscription.unsubscribe();
  }, []);
  return null;
}
